import { render, staticRenderFns } from "./about.vue?vue&type=template&id=634bf2be&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634bf2be')) {
      api.createRecord('634bf2be', component.options)
    } else {
      api.reload('634bf2be', component.options)
    }
    module.hot.accept("./about.vue?vue&type=template&id=634bf2be&", function () {
      api.rerender('634bf2be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/description/components/about.vue"
export default component.exports